import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "recipe-stats" }
const _hoisted_2 = { class: "stat-card" }
const _hoisted_3 = { class: "stat-number" }
const _hoisted_4 = { class: "stat-card" }
const _hoisted_5 = { class: "stat-number" }
const _hoisted_6 = { class: "stat-card" }
const _hoisted_7 = { class: "stat-number" }
const _hoisted_8 = { class: "stat-card" }
const _hoisted_9 = { class: "stat-number" }

import { computed } from 'vue';
import type { Recipe } from '@/types/recipe';


export default /*@__PURE__*/_defineComponent({
  __name: 'RecipeStats',
  props: {
    recipes: {}
  },
  setup(__props: any) {

const props = __props;

const easyRecipes = computed(
  () => props.recipes.filter((r) => r.difficulty === 'EASY').length
);

const mediumRecipes = computed(
  () => props.recipes.filter((r) => r.difficulty === 'MEDIUM').length
);

const hardRecipes = computed(
  () => props.recipes.filter((r) => r.difficulty === 'HARD').length
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.recipes.length), 1),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "stat-label" }, "Total Recipes", -1))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, _toDisplayString(easyRecipes.value), 1),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "stat-label" }, "Easy Recipes", -1))
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, _toDisplayString(mediumRecipes.value), 1),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "stat-label" }, "Medium Recipes", -1))
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, _toDisplayString(hardRecipes.value), 1),
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "stat-label" }, "Hard Recipes", -1))
    ])
  ]))
}
}

})